import React from 'react';
const IconMiscSecurityFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 1.91H3V9.91C3 17.37 7.63 20.34 12 22.53C16.38 20.34 21 17.37 21 9.91V1.91ZM11.5 14.33L8.29 11.12L9.71 9.7L11.5 11.49L15.29 7.7L16.7 9.11L11.5 14.33Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconMiscSecurityFill;